import EfIcon from '@elem/ui/ef-icon';
import EfImg from '@elem/ui/ef-img';
import { useProductStore } from '../../ProductProvider';
import { PAGE_TYPE } from '../../constants';
import { IconElectric, IconDrill, IconFan, IconLight } from './icons';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.TabA');
    const { pageType } = useProductStore();
    const BG_MAP: any = {
        [PAGE_TYPE.BASE]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726040049667/pc_taba_4_base.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726040050009/m_taba_4_base.jpg',
        },
        [PAGE_TYPE.MOTOR]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725851346299/pc_taba_4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725851345762/m_taba_4.jpg',
        },
    };
    const bg = BG_MAP[pageType];

    return (
        <div className="ef-container TabA-card card-d">
            <div className="TabA-card-l">
                <EfImg pc={bg.pc} h5={bg.h5} />
            </div>
            <div className="TabA-card-r">
                <div className="TabA-card-r-in">
                    <div className="TabA-card-title">{t('d_title')}</div>
                    <div className="TabA-card-list">
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <IconElectric />
                            </div>
                            <div className="TabA-card-item-text1">
                                1<span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('d_item1_t2')}</div>
                        </div>
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <IconDrill />
                            </div>
                            <div className="TabA-card-item-text1">
                                1<span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('d_item2_t2')}</div>
                        </div>
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <IconFan />
                            </div>
                            <div className="TabA-card-item-text1">
                                8<span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('d_item3_t2')}</div>
                        </div>
                        <div className="TabA-card-item">
                            <div className="TabA-card-item-icon">
                                <IconLight />
                            </div>
                            <div className="TabA-card-item-text1">
                                12<span className="unit">{t('unit')}</span>
                            </div>
                            <div className="TabA-card-item-text2">{t('d_item4_t2')}</div>
                        </div>
                    </div>
                    <div className="TabA-card-bg">
                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1726639176163/Workshop.png" />
                    </div>
                    <div className="TabA-card-tag">{t('d_text1')}</div>
                    <div className="TabA-card-tips">{t('d_text2')}</div>
                </div>
            </div>
        </div>
    );
}
